import { StarIcon } from "@heroicons/react/24/solid"
import React from "react"
import { twMerge } from "tailwind-merge"

const ReviewStars = ({ rating, starClassName, filledColor, emptyColor }) => {
  // Ensure rating is a number and handle edge cases
  const numericRating = typeof rating === "number" ? rating : 0
  const clampedRating = Math.max(0, Math.min(5, numericRating))

  // Use theme colors if provided, otherwise fallback to default Tailwind classes
  const filledStarClass = filledColor ? "" : "text-orange"
  const emptyStarClass = emptyColor ? "" : "text-gray"

  const filledStarStyle = filledColor ? { color: filledColor } : {}
  const emptyStarStyle = emptyColor ? { color: emptyColor } : {}

  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, index) => {
        const starNumber = index + 1
        const isFilled = starNumber <= Math.floor(clampedRating)
        const isPartial = starNumber === Math.ceil(clampedRating) && clampedRating % 1 !== 0

        return (
          <div key={index} className="relative">
            {/* Empty star background */}
            <StarIcon className={twMerge("h-5 w-5", emptyStarClass, starClassName)} style={emptyStarStyle} />
            {/* Filled star overlay */}
            {isFilled && (
              <StarIcon
                className={twMerge("absolute left-0 top-0 h-5 w-5", filledStarClass, starClassName)}
                style={filledStarStyle}
              />
            )}
            {/* Partial star for decimal ratings */}
            {isPartial && (
              <div
                className="absolute left-0 top-0 overflow-hidden"
                style={{
                  width: `${(clampedRating % 1) * 100}%`,
                  height: "100%"
                }}>
                <StarIcon className={twMerge("h-5 w-5", filledStarClass, starClassName)} style={filledStarStyle} />
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ReviewStars
